// comments only in English
import gsap from "gsap";

export default function initShare() {
  const root = document.getElementById("share");
  if (!root) return;

  const toggle = root.querySelector(".share__toggle");
  const bar = root.querySelector(".share__bar");
  const btnFacebook = root.querySelector(".share__btn--facebook");
  const btnWhatsapp = root.querySelector(".share__btn--whatsapp");
  const btnCopy = root.querySelector(".share__btn--copy");
  const btnEmail = root.querySelector(".share__btn--email");
  const toast = root.querySelector(".share__toast");

  // resolve URL and title (data attributes override)
  const pageUrl = (root.getAttribute("data-share-url") || window.location.href).trim();
  const pageTitle = (root.getAttribute("data-share-title") || document.title).trim();

  // prebuild hrefs
  const encodedUrl = encodeURIComponent(pageUrl);
  const encodedTitle = encodeURIComponent(pageTitle);

  btnFacebook.setAttribute("href", `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
  btnWhatsapp.setAttribute("href", `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`);
  btnEmail.setAttribute("href", `mailto:?subject=${encodedTitle}&body=${encodedUrl}`);

  // open/close timeline
  const tl = gsap.timeline({ paused: true });
  const fullWidth = () => {
    const w = getNaturalWidth(bar);
    return Math.max(180, Math.min(w, 460));
  };

  tl.set(bar, { visibility: "visible" })
    .fromTo(bar, { width: 0 }, { width: fullWidth, duration: 0.28, ease: "power2.out" }, 0)
    .fromTo(
      bar.querySelectorAll(".share__btn"),
      { x: -8, opacity: 0 },
      { x: 0, opacity: 1, stagger: 0.05, duration: 0.18, ease: "power2.out" },
      0.08
    );

  let isOpen = false;

  const open = () => {
    if (isOpen) return;
    tl.invalidate().play(0);
    root.classList.add("is-open");
    bar.setAttribute("aria-hidden", "false");
    isOpen = true;

    // click outside to close
    document.addEventListener("click", handleOutside, { passive: true });
  };

  const close = () => {
    if (!isOpen) return;
    gsap.to(bar, { width: 0, duration: 0.22, ease: "power2.in", onComplete: () => {
      gsap.set(bar, { visibility: "hidden" });
    }});
    gsap.to(bar.querySelectorAll(".share__btn"), { x: -8, opacity: 0, duration: 0.15, stagger: { each: 0.04, from: "end" } });
    root.classList.remove("is-open");
    bar.setAttribute("aria-hidden", "true");
    isOpen = false;
    document.removeEventListener("click", handleOutside);
  };

  const toggleOpen = (e) => {
    e.stopPropagation();
    isOpen ? close() : open();
  };

  const handleOutside = (e) => {
    if (root.contains(e.target)) return;
    close();
  };

  toggle.addEventListener("click", toggleOpen);

  // copy to clipboard with feedback
  btnCopy.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      showToast();
    } catch (err) {
      // fallback for older browsers
      const ta = document.createElement("textarea");
      ta.value = pageUrl;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); showToast(); }
      catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    }
  });

  function showToast() {
    gsap.killTweensOf(toast);
    toast.setAttribute("data-state", "visible");
    gsap.fromTo(
      toast,
      { y: -6, scale: 0.96, opacity: 0 },
      { y: 0, scale: 1, opacity: 1, duration: 0.18, ease: "power2.out" }
    );
    gsap.to(toast, { opacity: 0, y: -4, duration: 0.22, delay: 1.1, ease: "power2.in", onComplete: () => {
      toast.setAttribute("data-state", "hidden");
    }});
  }

  function getNaturalWidth(el) {
    const prevWidth = el.style.width;
    const prevVis = el.style.visibility;
    el.style.visibility = "hidden";
    el.style.width = "auto";
    const w = el.getBoundingClientRect().width;
    el.style.width = prevWidth;
    el.style.visibility = prevVis;
    return w;
  }
}
